export default function exceptionBuilder(builder, payload = {}) {
  const { exceptionsById } = payload || {}

  if (!exceptionsById) return

  Object.values(exceptionsById).forEach(exceptionList => {
    builder.addChanges(exceptionList, {
      entityName: 'Exception',
      fieldConfig: {
        exceptionType: 'Type',
        noteText: 'Note',
        // PENDING -> CONFIRMED/REJECTED, so the feed records who reviewed a Vision
        // detection and when, attributed to that revision's lastModifiedBy.
        confirmationStatus: 'Review status',
      },
    })
  })
}
